import { render, staticRenderFns } from "./SingleChoiceV1.vue?vue&type=template&id=326cd172&"
import script from "./SingleChoiceV1.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports